<template>
  <el-card class="m-4">
    <h1>Vue.js + Frappe Gantt Demo</h1>

    <el-button-group>
      <el-button @click="demoViewMode('Day')">Day View Mode</el-button>
      <el-button @click="demoViewMode('Week')">Week View Mode</el-button>
      <el-button @click="demoViewMode('Month')">Month View Mode</el-button>
    </el-button-group>

    <frappe-gantt
      class="mt-2 mb-2 debug-border"
      :view-mode="mode"
      :tasks="tasks"
      @task-clicked="debugEventLog.push($event)"
      @task-date-updated="debugEventLog.push($event)"
      @task-progress-updated="debugEventLog.push($event)"
    />

    <el-button-group>
      <el-button @click="addRandomTask">Add random task</el-button>
      <el-button @click="onClearEvents">Clear events</el-button>
    </el-button-group>

    <h5>Events</h5>
    <ul>
      <li v-for="(event, index) in debugEventLog" :key="index">
        <pre class="mini-pre">{{ event }}</pre>
      </li>
    </ul>

  </el-card>
</template>

<script>
import FrappeGantt from "@/components/Elements/Charts/FrappeGantt.vue";
// import moment from "@/moment-gp.js";

// TODO: When the Frappe Chart component emits task changes from user clicking or dragging make sure to then update
//       the task list passed in via prop (App.vue)

export default {
  components: {
    FrappeGantt,
  },
  data() {
    return {
      mode: "Week",
      tasks: [
        {
          id: "1",
          name: "Hello",
          start: "2019-01-01",
          end: "2019-01-05",
          progress: 10,
        },
        {
          id: "2",
          name: "World",
          start: "2019-01-05",
          end: "2019-01-10",
          progress: 20,
          dependencies: "1",
        },
        {
          id: "3",
          name: "From",
          start: "2019-01-10",
          end: "2019-01-15",
          progress: 30,
          dependencies: "2",
        },
        {
          id: "4",
          name: "Lloyd",
          start: "2019-01-15",
          end: "2019-01-20",
          progress: 40,
          dependencies: "3, 1",
        },
      ],
      debugEventLog: [],
    };
  },
  methods: {
    addRandomTask() {
      const id = 'X' + parseInt( 10000 * Math.random() );
      console.log("id", id)
      this.tasks.push({
        id: id,
        name: 'hello',
        start: "2019-01-01",
        end: "2019-01-05",
        progress: Math.random() * 100,
      });
    },
    demoViewMode(viewMode) {
      this.mode = viewMode;
    },
    onClearEvents() {
      this.debugEventLog = [];
    },
  },
};
</script>
